<template>
  <div class="w-full" :data-testid="props.dataTestid">
    <TsImage class="w-full h-64 rounded-lg object-cover" :alt="alt" :src="image" :data-testid="props.dataTestid+'-img'" loading="lazy"/>
    <TsTypography :data-testid="props.dataTestid+'-title'" as="h3" variant="h2" appendClass="text-natural-grey dark:text-gray-400 py-0 text-2xl font-normal text-center mt-5">
      {{title}}
    </TsTypography>
  </div>
</template>

<script setup lang="ts">
type Props = {
  title?: string;
  image?: string;
  alt?: string | number;
  dataTestid:string;
};

const props = withDefaults(defineProps<Props>(), {
});
</script>

